module.exports = __webpack_public_path__ + "img/1552118094.52561df7.jpg";